import { render, staticRenderFns } from "./VerticalToggler.vue?vue&type=template&id=7ed024c5&"
import script from "./VerticalToggler.vue?vue&type=script&lang=js&"
export * from "./VerticalToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports